import { render, staticRenderFns } from "./SmsNotificationsAvailableAgain.vue?vue&type=template&id=29bfa19c&scoped=true&"
import script from "./SmsNotificationsAvailableAgain.vue?vue&type=script&lang=js&"
export * from "./SmsNotificationsAvailableAgain.vue?vue&type=script&lang=js&"
import style0 from "./SmsNotificationsAvailableAgain.vue?vue&type=style&index=0&id=29bfa19c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29bfa19c",
  null
  
)

export default component.exports